export function emptyRenderBundle() {
    return {
        fills: [],
        lines: [],
        points: [],
        labels: [],
        hitAreas: [],
    };
}
export function createPlotFeature(input) {
    return {
        id: input.id,
        plotType: input.plotType,
        definitionVersion: input.definitionVersion ?? "1.0.0",
        controlPoints: input.controlPoints.map(([longitude, latitude]) => [longitude, latitude]),
        parameters: { ...(input.parameters ?? {}) },
        style: { ...(input.style ?? {}) },
        metadata: { ...(input.metadata ?? {}) },
        revision: input.revision ?? 0,
    };
}
export function clonePlotFeature(feature) {
    return createPlotFeature(feature);
}
//# sourceMappingURL=types.js.map